import validator from 'validator';
import Errors, { MAX_CHAR, MAX_PHONE_NUMBER } from './validateHelper';

const validateModalku = values => {
  const errors = new Errors();
  const { is_address_same_as_ktp: isAddressSameAsKTPAddress } = values;
  // ---------- Validate PERSONAL INFORMATION ----------
  errors.validateRequiredFields(values, [
    'full_name',
    'email',
    'phone_number',
    'nik',
    'place_of_birth',
    'gender',
    'marital_status',
    'ktp_address',
    'ktp_province',
    'ktp_city',
    'ktp_zipcode',
    'current_residence_ownership',
  ]);

  if (values.full_name && values.full_name.length > MAX_CHAR) {
    errors.full_name = 'The maximum character is only 255';
  }

  if (values.email && !validator.isEmail(values.email)) {
    errors.email = 'The value is not a valid email address';
  } else if (values.email && values.email.length > MAX_CHAR) {
    errors.email = 'The maximum character is only 255';
  }

  if (
    values.phone_number &&
    (values.phone_number.length < 9 ||
      values.phone_number.length > MAX_PHONE_NUMBER)
  ) {
    errors.phone_number = 'Please enter a valid phone number';
  }

  if (
    values.other_phone_number &&
    (values.other_phone_number.length < 9 ||
      values.other_phone_number.length > MAX_PHONE_NUMBER)
  ) {
    errors.other_phone_number = 'Please enter a valid phone number';
  }

  if (values.nik && values.nik.length > MAX_CHAR) {
    errors.nik = 'The maximum character is only 255';
  }

  if (values.place_of_birth && values.place_of_birth.length > MAX_CHAR) {
    errors.place_of_birth = 'The maximum character is only 255';
  }

  if (values.ktp_city && values.ktp_city.length > MAX_CHAR) {
    errors.ktp_city = 'The maximum character is only 255';
  }

  if (values.ktp_address && values.ktp_address.length > MAX_CHAR) {
    errors.ktp_address = 'The maximum character is only 255';
  }

  if (!isAddressSameAsKTPAddress) {
    errors.validateRequiredFields(values, [
      'address',
      'home_province',
      'home_city',
      'home_zipcode',
    ]);
  }

  if (!values.birth_date) {
    errors.birth_date = 'Please enter a value';
  }

  // ---------- Validate BUSINESS INFORMATION ----------
  errors.validateRequiredFields(values, [
    'business_name',
    'business_address',
    'business_province',
    'business_city',
    'business_zipcode',
    'business_start_month',
    'business_start_year',
    'business_residence_ownership',
  ]);

  if (values.business_name && values.business_name.length > MAX_CHAR) {
    errors.business_name = 'The maximum character is only 255';
  }

  if (values.business_address && values.business_address.length > MAX_CHAR) {
    errors.business_address = 'The maximum character is only 255';
  }

  if (values.business_city && values.business_city.length > MAX_CHAR) {
    errors.business_city = 'The maximum character is only 255';
  }

  // ---------- validate Loan Purpose ----------
  if (!values.loan_purpose) {
    errors.loan_purpose = 'Please enter a value';
  } else if (values.loan_purpose.trim() === '') {
    errors.loan_purpose = 'Please enter a value';
  } else if (values.loan_purpose.length > MAX_CHAR) {
    errors.loan_purpose = 'Max character for loan purpose is 255';
  }

  // ---------- Validate upload documents ----------
  if (values.ktp_spouse_file) {
    errors.validateJPEGFields(values, ['ktp_spouse_file']);
  }

  if (values.siup_file) {
    errors.validateJPEGFields(values, ['siup_file']);
  }

  if (values.outlet_picture_file) {
    errors.validateJPEGFields(values, ['outlet_picture_file']);
  }

  if (values.pre_approved_amount > 100000000) {
    errors.validateJPEGFields(values, [
      'bank_statement_1_file',
      'bank_statement_2_file',
      'bank_statement_3_file',
    ]);
  }

  errors.validateJPEGFields(values, ['ktp_file', 'npwp_file']);

  return errors;
};

export default validateModalku;
